import { useState } from "react";
import { motion } from "framer-motion";
import Button from "../base/Button";

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
    setIsMenuOpen(false);
  };

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50 overflow-hidden">
      <div className="max-w-7xl mx-auto px-2 sm:px-4 lg:px-6">
        <div className="flex items-center justify-between h-16 sm:h-18 md:h-20">
          <div className="flex items-center -ml-1 sm:-ml-2 md:-ml-6 lg:-ml-10 xl:-ml-12 max-w-[70%] sm:max-w-none">
            <img
              src="/images/logos/app-logo2.png"
              alt="Pamag Healthcare Services LLC Icon"
              className="h-14 sm:h-16 md:h-18 lg:h-20 w-auto"
            />
            <span className="-ml-6 sm:-ml-7 md:-ml-8 lg:-ml-9 self-center text-sm xs:text-base sm:text-lg md:text-xl lg:text-xl xl:text-xl font-extrabold tracking-wide bg-gradient-to-r from-emerald-700 via-emerald-600 to-teal-600 bg-clip-text text-transparent whitespace-nowrap leading-none drop-shadow-sm">
              PAMAG HEALTH CARE SERVICES LLC
            </span>
          </div>

          <nav className="hidden lg:flex space-x-6 xl:space-x-8 flex-1 justify-center -ml-32 xl:-ml-40">
            <motion.button
              onClick={() => scrollToSection("home")}
              className="text-gray-700 hover:text-teal-600 cursor-pointer transition-colors text-sm xl:text-base"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Home
            </motion.button>
            <motion.button
              onClick={() => scrollToSection("services")}
              className="text-gray-700 hover:text-teal-600 cursor-pointer transition-colors text-sm xl:text-base"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Services
            </motion.button>
            <motion.button
              onClick={() => scrollToSection("about")}
              className="text-gray-700 hover:text-teal-600 cursor-pointer transition-colors text-sm xl:text-base"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              About
            </motion.button>
            <motion.button
              onClick={() => scrollToSection("contact")}
              className="text-gray-700 hover:text-teal-600 cursor-pointer transition-colors text-sm xl:text-base"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Contact
            </motion.button>
          </nav>

          <div className="hidden lg:block ml-auto">
            <Button
              onClick={() => scrollToSection("contact")}
              className="text-xs xl:text-sm px-3 xl:px-4 py-2"
            >
              Get Started
            </Button>
          </div>

          <button
            className="lg:hidden w-10 h-10 flex items-center justify-center cursor-pointer ml-auto"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle menu"
          >
            <i
              className={`ri-${isMenuOpen ? "close" : "menu"}-line text-2xl`}
            ></i>
          </button>
        </div>

        {isMenuOpen && (
          <div className="lg:hidden py-4 border-t">
            <div className="flex flex-col space-y-3 sm:space-y-4">
              <button
                onClick={() => scrollToSection("home")}
                className="text-gray-700 hover:text-teal-600 cursor-pointer transition-colors text-left text-sm sm:text-base py-2"
              >
                Home
              </button>
              <button
                onClick={() => scrollToSection("services")}
                className="text-gray-700 hover:text-teal-600 cursor-pointer transition-colors text-left text-sm sm:text-base py-2"
              >
                Services
              </button>
              <button
                onClick={() => scrollToSection("about")}
                className="text-gray-700 hover:text-teal-600 cursor-pointer transition-colors text-left text-sm sm:text-base py-2"
              >
                About
              </button>
              <button
                onClick={() => scrollToSection("contact")}
                className="text-gray-700 hover:text-teal-600 cursor-pointer transition-colors text-left text-sm sm:text-base py-2"
              >
                Contact
              </button>
              <Button
                onClick={() => scrollToSection("contact")}
                className="w-full text-sm sm:text-base py-2 mt-2"
              >
                Get Started
              </Button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
